"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Confetti = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Confetti() {
    var _this;
    _classCallCheck(this, Confetti);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Confetti, [].concat(args));
    _defineProperty(_this, "makeConfetti", function () {
      // globals
      var canvas;
      var ctx;
      var W;
      var H;
      var mp = 150; // max particles
      var particles = [];
      var angle = 0;
      var tiltAngle = 0; // eslint-disable-line
      var confettiActive = true;
      var animationComplete = true;
      var reactivationTimerHandler; // eslint-disable-line
      var animationHandler; // eslint-disable-line

      // objects
      var particleColors = {
        colorOptions: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson'],
        colorIndex: 0,
        colorIncrementer: 0,
        colorThreshold: 10,
        getColor: function getColor() {
          if (this.colorIncrementer >= 10) {
            this.colorIncrementer = 0;
            this.colorIndex++;
            if (this.colorIndex >= this.colorOptions.length) {
              this.colorIndex = 0;
            }
          }
          this.colorIncrementer++;
          return this.colorOptions[this.colorIndex];
        }
      };
      function ConfettiParticle(color) {
        this.x = Math.random() * W; // x-coordinate
        this.y = Math.random() * H - H; // y-coordinate
        this.r = RandomFromTo(10, 30); // radius;
        this.d = Math.random() * mp + 10; // density;
        this.color = color;
        this.tilt = Math.floor(Math.random() * 10) - 10;
        this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
        this.tiltAngle = 0;

        // eslint-disable-next-line
        this.draw = function () {
          ctx.beginPath();
          ctx.lineWidth = this.r / 2;
          ctx.strokeStyle = this.color;
          ctx.moveTo(this.x + this.tilt + this.r / 4, this.y);
          ctx.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4);
          return ctx.stroke();
        };
      }
      document.addEventListener('DOMContentLoaded', function () {
        SetGlobals();
        InitializeConfetti();
        window.addEventListener('resize', function () {
          W = window.innerWidth;
          H = window.innerHeight;
          canvas.width = W;
          canvas.height = H;
        });
      });
      function SetGlobals() {
        canvas = document.getElementById('confetti');
        ctx = canvas.getContext('2d');
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;
      }
      function InitializeConfetti() {
        particles = [];
        animationComplete = false;
        for (var i = 0; i < mp; i++) {
          var particleColor = particleColors.getColor();
          particles.push(new ConfettiParticle(particleColor));
        }
        StartConfetti();
      }
      function Draw() {
        ctx.clearRect(0, 0, W, H);
        var results = [];
        for (var i = 0; i < mp; i++) {
          // eslint-disable-next-line
          (function (j) {
            results.push(particles[j].draw());
          })(i);
        }
        Update();
        return results;
      }
      function RandomFromTo(from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
      }
      function Update() {
        var remainingFlakes = 0;
        var particle;
        angle += 0.01;
        tiltAngle += 0.1;
        for (var i = 0; i < mp; i++) {
          particle = particles[i];
          if (animationComplete) return;
          if (!confettiActive && particle.y < -15) {
            particle.y = H + 100;
            continue;
          }
          stepParticle(particle, i);
          if (particle.y <= H) {
            remainingFlakes++;
          }
          CheckForReposition(particle, i);
        }
        if (remainingFlakes === 0) {
          StopConfetti();
        }
      }
      function CheckForReposition(particle, index) {
        if ((particle.x > W + 20 || particle.x < -20 || particle.y > H) && confettiActive) {
          if (index % 5 > 0 || index % 2 === 0) {
            // 66.67% of the flakes
            repositionParticle(particle, Math.random() * W, -10, Math.floor(Math.random() * 10) - 20);
          } else if (Math.sin(angle) > 0) {
            // Enter from the left
            repositionParticle(particle, -20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
          } else {
            // Enter from the right
            repositionParticle(particle, W + 20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
          }
        }
      }
      function stepParticle(particle, particleIndex) {
        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(angle + particle.d) + 3 + particle.r / 2) / 2;
        particle.x += Math.sin(angle);
        particle.tilt = Math.sin(particle.tiltAngle - particleIndex / 3) * 15;
      }
      function repositionParticle(particle, xCoordinate, yCoordinate, tilt) {
        particle.x = xCoordinate;
        particle.y = yCoordinate;
        particle.tilt = tilt;
      }
      function StartConfetti() {
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;
        (function animloop() {
          if (animationComplete) return null;
          animationHandler = window.requestAnimationFrame(animloop);
          return Draw();
        })();
      }

      /*
      function ClearTimers() {
          clearTimeout(reactivationTimerHandler);
          clearTimeout(animationHandler);
      }
      */

      function StopConfetti() {
        animationComplete = true;
        if (ctx === undefined) return;
        ctx.clearRect(0, 0, W, H);
      }
    });
    return _this;
  }
  _inherits(Confetti, _React$Component);
  return _createClass(Confetti, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.makeConfetti();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("canvas", {
        className: _style["default"].fullscreen,
        style: {
          position: this.props.positionOverride
        },
        id: "confetti"
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(Confetti, "propTypes", {
  positionOverride: _propTypes["default"].string
});
_defineProperty(Confetti, "defaultProps", {
  positionOverride: 'fixed'
});